module.exports = __webpack_public_path__ + "static/media/dollar-bill.e2e62378.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dollar-bill.svg
// module id = 860
// module chunks = 0